module.exports = __webpack_public_path__ + "img/vitoria-hotel-concept-campinas.f120e35d.png";